import React from 'react'

function SelectInput({
  name,
  options,
  formState,
  onChangeHandler,
  labelText,
  placeholder,
  toDisplay,
  isDisabled,
  state,
  screen,
}) {
  return (
    <div className='mb-3 select-input'>
      <label htmlFor={name} className='form-label'>
        {labelText}<span className="text-danger">*</span>
      </label>
      <select
        className='form-select'
        id={name}
        name={name}
        disabled={formState !== 'idle' || isDisabled}
        value={state}
        onChange={onChangeHandler}>
        <option disabled defaultChecked>
          {placeholder}
        </option>
        {options.map((element, i) => (
          <option value={screen === 'issue' ? element['title'] + '-' + element['version'] : element} key={i}>
            {screen === 'issue' ? element['title'] + ' - ' + element['version'] : element}
          </option>
        ))}
      </select>
    </div>
  )
}

export default SelectInput
